import React from "react";
import { ManageTestimonialsContent } from "../components/AdminSettings/TestimonialsMaster/ManageTestimonialsContent";
import { ToastContainer } from "react-toastify";

export const TestimonialsMaster = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageTestimonialsContent />
        </div>
      </div>
    </div>
  );
};
